// extracted by mini-css-extract-plugin
export default {"wrapper":"Type_wrapper__fkK-V","content":"Type_content__fFTz8","icon":"Type_icon__42DWB"};